import React from "react";
import loader from "../Assets/loader.svg";

const Loader = () => {
  return (
    <div
      style={{
        display: "block",
        textAlign: "center",
        backgroundColor: "white",
        padding: "1rem 0",
      }}
    >
      <img src={loader} alt="Loader" />
    </div>
  );
};

export default Loader;
